import { Component, inject, input } from '@angular/core';
import {
  OnyxIconButtonComponent,
  OnyxOverlayPosition,
  OnyxTooltipDirective,
} from '@onyx/angular';
import { StorageService } from '../../../services/storage.service';

@Component({
  selector: 'app-modal-documents-buttons',
  imports: [OnyxIconButtonComponent, OnyxTooltipDirective],
  templateUrl: './modal-documents-buttons.component.html',
  styleUrl: './modal-documents-buttons.component.scss',
})
export class DriverModalDocumentsButtonsComponent {
  private readonly storageService = inject(StorageService);

  public readonly scans = input.required<string[] | null>();

  protected readonly OnyxOverlayPosition = OnyxOverlayPosition;

  protected showFiles(): void {
    const scans = this.scans();
    if (!scans) return;

    for (const scan of scans) {
      this.storageService.previewFile(scan).subscribe();
    }
  }

  protected downloadFiles(): void {
    const scans = this.scans();
    if (!scans) return;

    for (const scan of scans) {
      this.storageService.downloadFile(scan).subscribe();
    }
  }
}
